import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/kurs-tools/betriebsferien`;

export default function Betriebsferien() {
  const [liste, setListe] = useState([]);
  useEffect(() => { axios.get(API).then((r) => setListe(r.data.zeitraeume || [])).catch(() => toast.error("Konnte nicht geladen werden")); }, []);
  const setze = (i, k, v) => setListe(liste.map((z, j) => (j === i ? { ...z, [k]: v } : z)));
  const speichern = async () => {
    try { const r = await axios.put(API, { zeitraeume: liste }); setListe(r.data.zeitraeume); toast.success("Betriebsferien gespeichert"); }
    catch (err) { toast.error(err.response?.data?.detail || "Speichern fehlgeschlagen"); }
  };
  return (
    <div className="p-4 sm:p-8 max-w-3xl" data-testid="betriebsferien-page">
      <h1 className="text-3xl font-semibold text-stone-900">Betriebsferien</h1>
      <p className="text-sm text-stone-600 mt-1 mb-6">Diese Tage werden bei Kursende, BG-Angeboten, Klassenbuch und Anwesenheit wie Feiertage übersprungen. Bitte pro Jahr eintragen.</p>
      <div className="space-y-3">
        {liste.map((z, i) => (
          <div key={i} className="flex flex-wrap items-center gap-2 rounded-lg border border-stone-200 bg-white p-3" data-testid={`ferien-zeile-${i}`}>
            <Input type="date" value={z.von} onChange={(e) => setze(i, "von", e.target.value)} className="w-40" data-testid={`ferien-von-${i}`} />
            <span className="text-stone-500">bis</span>
            <Input type="date" value={z.bis} onChange={(e) => setze(i, "bis", e.target.value)} className="w-40" data-testid={`ferien-bis-${i}`} />
            <Input value={z.bezeichnung || ""} onChange={(e) => setze(i, "bezeichnung", e.target.value)} placeholder="Bezeichnung" className="flex-1 min-w-[140px]" data-testid={`ferien-bez-${i}`} />
            <Button variant="ghost" size="sm" onClick={() => setListe(liste.filter((_, j) => j !== i))} data-testid={`ferien-loeschen-${i}`}><Trash2 size={16} /></Button>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-4">
        <Button variant="outline" onClick={() => setListe([...liste, { von: "", bis: "", bezeichnung: "Betriebsferien" }])} data-testid="ferien-neu-btn"><Plus size={16} className="mr-1" />Zeitraum hinzufügen</Button>
        <Button onClick={speichern} data-testid="ferien-speichern-btn"><Save size={16} className="mr-1" />Speichern</Button>
      </div>
    </div>
  );
}
